<template>
  <div class="container mt-4">
    <h3>{{ isEdit ? "Edit Category" : "New Category" }}</h3>

    <div class="card p-3">

      <div class="mb-3">
        <label class="form-label">Category Name</label>
        <input type="text" class="form-control" v-model="category.name" placeholder="Category name" />
      </div>

      <div>
        <label class="form-label">Attributes</label>

        <div v-for="(attr, index) in category.attributes" :key="index" class="input-group mb-2">
          <input
            type="text"
            class="form-control"
            v-model="attr.name"
            placeholder="Attribute name"
          />
          <button class="btn btn-danger" @click="removeAttribute(index)">X</button>
        </div>

        <button class="btn btn-sm btn-outline-primary" @click="addAttribute">
          + Add Attribute
        </button>
      </div>

      <div class="text-end mt-4">
        <button class="btn btn-secondary me-2" @click="$router.back()">Cancel</button>
        <button class="btn btn-success" @click="saveCategory">
          Save Category
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { categoryApi } from "@/api/productApi";
import notify from "@/utils/swal.js";

export default {
  props: ["id"],

  data() {
    return {
      isEdit: false,
      category: {
        name: "",
        attributes: []
      }
    };
  },

  async created() {
    if (this.id) {
      this.isEdit = true;
      const res = await categoryApi.getById(this.id);
      this.category = res.data;
    }
  },

  methods: {
    addAttribute() {
      this.category.attributes.push({ name: "" });
    },
    removeAttribute(index) {
      this.category.attributes.splice(index, 1);
    },
    async saveCategory() {
      if (!this.category.name) {
        return notify.warning("Category name is required.");
      }

      try {
        let res;

        if (this.isEdit) {
          res = await categoryApi.update(this.id, this.category);
        } else {
          res = await categoryApi.create(this.category);
        }

        notify.success("Category saved successfully!", res.data.name);

              this.$router.push({
        path: "/form",   // <-- The dynamic form route
        query: { menu: "New Product" }
      });

      } catch (error) {
        console.error("Error saving category:", error);
        notify.error("Could not save category.");
      }
    }
  }
};
</script>

<style scoped>
.card {
  max-width: 600px;
  margin: auto;
}
</style>
